/**
 * @author Kumaravel Pazhani
 * @email kumaravel@qdmplatforms.com
 * @create 12/12/202
 * @modify 12/12/202
 * @desc Providing the assemble registration from /src/context which is used in /src/App.js
 */

import React, { useEffect, useState } from "react";

import axios from "axios";
import { PatientRegContext, VitalMastersContext, EnvContext } from "./";
import { paraCode } from "../utils";
import { setConfig } from "../utils/envBridge";
import setBinderRuntimeEnv from "primary_care_admin_binder";




const Practitionet = (props) => {
  // Existing contexts
  const [patientData, setPatientData] = useState({
    identification: [{}],
    names: [{}],
    details: {},
    practitioner_description: {},
    communication: {},
    contact: [{}],
    Submitrole: {},
    address: [],
    publication: [{}],
    reporting: {},
    practitionerbyrole: [],
    qualification: [],
    training: [],
    job: [],
    awards: [],
  });

  const [vitalMaster, setVitalMaster] = useState({
    measureCode: [
      {
        column1: "KG/M2",
        column2: "kg/m2",
        column3: "kg/m2",
        status: "Active",
      },
      {
        column1: "POUNDS",
        column2: "lb",
        column3: "Pounds",
        status: "inactive",
      },
      {
        column1: "GRAM",
        column2: "Gram",
        column3: "Gram",
        status: "Active",
      },
    ],
    vitalMaster: [],
  });

  // ✅ New Environment Data Context
  const [envConfig, setEnvConfig] = useState({});
  const [loadingEnv, setLoadingEnv] = useState(true);

  // Fetch runtime ENV parameters when requested. We expose fetchEnvData so
  // callers (e.g. SignIn) can trigger it after a token is available.
  const fetchEnvData = async () => {
    setLoadingEnv(true);
    try {
      const params = { paraCode: [paraCode] };
      const configObj = {
        method: "post",
        url: `${process.env.REACT_APP_GET_ALL_PARAMS}/api/getAllParams`,
        data: params,
      };
      const response = await axios(configObj);
      const data = response?.data?.response[0]?.paraobj?.[0] || {};

      setEnvConfig(data);
      setBinderRuntimeEnv(data); // Set Binder Config variable
      setConfig(data); // Set runtime env globally
      setLoadingEnv(false);
      return data;
    } catch (error) {
      console.error("Failed to load runtime environment:", error);
      setLoadingEnv(false);
      return null;
    }
  };

  // Optionally auto-fetch here if a token already exists in localStorage.
  // This keeps previous behavior for page reloads where token is present.
  useEffect(() => {
    const Token = localStorage.getItem("token")
    if (Token) {
      fetchEnvData();
    } else {
      setLoadingEnv(false);
    }
  }, []);

  return (
    <EnvContext.Provider value={{ envConfig, setEnvConfig, loadingEnv, fetchEnvData }}>
      <PatientRegContext.Provider value={{ ...patientData, setPatientData }}>
        <VitalMastersContext.Provider
          value={{ ...vitalMaster, setVitalMaster }}
        >
          {props.children}
        </VitalMastersContext.Provider>
      </PatientRegContext.Provider>
    </EnvContext.Provider>
  );
};

export default Practitionet;
